/**
 * Header — replaced by Sidebar component.
 * Navigation is now handled by src/components/ui/Sidebar.jsx via SidebarLayout.
 * This stub prevents import errors in pages that still reference Header.
 */
const Header = () => null;

export default Header;